import React from 'react'

import { Player } from 'video-react'

import {
    EuiText,
    EuiIcon,
    EuiPanel
  } from '@elastic/eui'

import { OutboundLink } from 'gatsby-plugin-gtag'

require('../../Layout/chrome/assets/video.css')

function VideoCard() {
  return (
    <EuiPanel paddingSize="m">
        <Player>
            <source src="https://wiki.instar.com/videos/Wie_funktioniert_eine_INSTAR_WLAN_IP_Kamera_.mp4" />
        </Player>
        <EuiText>
            <p>Animiertes Tutorial zur Funktionsweise einer INSTAR IP-Kamera. Was ist eine IP-Adresse? Wohin führt ein Port? Was ist eine DDNS-Adresse? Auf <OutboundLink href="https://www.youtube.com/watch?v=JWa1L_rBRW4" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
        </EuiText>
    </EuiPanel>
  );
}

export default VideoCard